import React from 'react';

import { FormattedMessageWrappedInSpan } from '../misc';

export default function GiftcardMessage() {
  return <FormattedMessageWrappedInSpan id="messages.giftcard" defaultMessage="Giftcard" />;
}
